module.exports = __webpack_public_path__ + "static/media/file_add.62c1e8a2.svg";